import { ClockCircleOutlined, DeleteOutlined, EditOutlined, FilterFilled, InfoCircleOutlined, SearchOutlined, VerticalAlignTopOutlined } from '@ant-design/icons';
import { BackTop, Breadcrumb, Empty, Menu, Row, Tooltip } from 'antd';
import { noop, isNil } from 'lodash';
import { httpCreators, Tags, useLoadingSelector } from '@ppvrbh/merchant-frontend-core';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { generalCreators } from '../../../redux/general/general-action';
import { MODAL_TYPE } from '../../../redux/general/general-constant';
import { GENERAL_STATE_KEY } from '../../../redux/general/general-reducer';
import {
  RBHAlert,
  RBHBanner,
  RBHBox,
  RBHButton,
  RBHError,
  RBHImage,
  RBHTable,
  RBHText,
  RBHTextInput
} from '../../../shared/components';
import styleButton from '../../../shared/components/rbh-button/styles';
import styleImage from '../../../shared/components/rbh-image/styles';
import RBHQCTag from '../../../shared/components/rbh-qc-tag';
import styleText from '../../../shared/components/rbh-text/styles';
import styleInput from '../../../shared/components/rbh-textinput/styles';
import { UtilHelper } from '../../../shared/helpers/utility';
import { Colors, Images } from '../../../shared/theme';
import commonStyle from '../../../shared/theme/common-style';
import metrics from '../../../shared/theme/metrics';
import { mainCreators } from '../../main-action';
import { MAIN_STATE_KEY } from '../../main-reducer';
import { MART_CATEGORY_REQUEST_ID_LIST } from '../MartCategory/redux/martCategory-constant';
import { martCategorySagas } from '../MartCategory/redux/martCategory-saga';
import { MartCategoryService } from '../MartCategory/redux/martCategory-service';
import { FormAddEdit } from './components/FormAddEdit';
import { martProductCreators } from './redux/martProduct-action';
import { MART_PAGINATION, MART_PRODUCT_LIST_PAGE_OPTION, MART_PRODUCT_REQUEST_ID_LIST, MART_PRODUCT_STATUS, PDQC_STATUS, PROMOTION_STATUS } from './redux/martProduct-constant';
import { MART_PRODUCT_STATE_KEY, martProductStateSelector } from './redux/martProduct-reducer';
import { martProductSagas } from './redux/martProduct-saga';
import { MartProductService } from './redux/martProduct-service';
import styles from './styles';
import './styles.css';
import moment from 'moment';

export const MartProductScreen: React.FC<Props> = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(martProductStateSelector(MART_PRODUCT_STATE_KEY.MART_PRODUCT)) as any;
  const loading = useLoadingSelector(MART_PRODUCT_REQUEST_ID_LIST.POST_MART_PRODUCT_INQUIRY);
  const totalItems = useSelector(martProductStateSelector(MART_PRODUCT_STATE_KEY.PRODUCT_TOTAL_ITEMS)) as number;
  const productStatusCode = [MART_PRODUCT_STATUS.ACTIVE, MART_PRODUCT_STATUS.INACTIVE];
  const [editData, setEditData] = useState<any>(null);
  const isAlertSuccess = useSelector(martProductStateSelector(MART_PRODUCT_STATE_KEY.IS_ALERT_SUCCESS));
  const isAlertFailure = useSelector(martProductStateSelector(MART_PRODUCT_STATE_KEY.IS_ALERT_FAILURE));
  const [currentPage, setCurrentPage] = useState(1);
  const [searchedProductName, setSearchedProductName] = useState<any>(null);
  const [productSorted, setProductSorted] = useState<any>(null);
  const [filteredProductStatus, setFilteredProductStatus] = useState<any>(null);
  const [offset, setOffset] = useState<number>(MART_PAGINATION.DEFAULT_OFFSET);
  const [limit, setLimit] = useState<number>(MART_PAGINATION.DEFAULT_LIMIT);
  const [pageSizeItems, setPageSizeItems] = useState<number>(MART_PAGINATION.DEFAULT_LIMIT);
  const [sortedInfo, setSortedInfo] = useState<any>({});
  const isLastPage = Math.ceil(totalItems / pageSizeItems) === currentPage;

  const reload = () => {
    dispatch(martProductCreators.callMartProductTnc({
      offset: MART_PAGINATION.DEFAULT_OFFSET,
      limit: MART_PAGINATION.DEFAULT_LIMIT
    }, true));
  };

  useEffect(() => {
    dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, 5));
    reload();
  }, []);

  const resetReload = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setEditData(null);
    setSearchedProductName(null);
    setProductSorted(null);
    setFilteredProductStatus(null);
    setSortedInfo({});
    setOffset(MART_PAGINATION.DEFAULT_OFFSET);
    setCurrentPage(MART_PAGINATION.DEFAULT_CURRENT);
    setLimit(MART_PAGINATION.DEFAULT_LIMIT);
    setPageSizeItems(MART_PAGINATION.DEFAULT_LIMIT);
    reload();
  };

  const pushToMartProduct = () => {
    resetReload();
  };

  const toPath = (path: string) => {
    history.push(path);
  };

  const onFilterClick = (setSelectedKeys: any, selectedKeys: any, confirm: any, clearFilters: any, value: any) => {
    setSelectedKeys([value]);
    confirm();
  };

  const deleteProduct = (productId: string) => {
    dispatch(httpCreators.request({
      id: MART_PRODUCT_REQUEST_ID_LIST.DELETE_MART_PRODUCT,
      sagaHandler: martProductSagas.deleteMartProductHandler as any,
      callbackParams: resetReload,
      service: MartProductService.deleteMartProduct,
      serviceParams: productId
    }));
  };

  const dispatchModal = (productId: string) => {
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => deleteProduct(productId),
      type: MODAL_TYPE.DELETE,
      modalTitle: 'main.mart.product.delete.modal.deleteConfirmation.title',
      modalContent: 'main.mart.product.delete.modal.deleteConfirmation.content'
    }));
  };

  const AlertBar = () => {
    if (isAlertSuccess) {
      return (
        <RBHBox id={'alertSuccess'} data-testid={'alertSuccess'}>
          <RBHAlert
            type={'success'}
            text={'main.mart.product.delete.alert.success'}
            autoCloseDuration={3000}
            afterClose={() => {
              dispatch(martProductCreators.setMartProductState(MART_PRODUCT_STATE_KEY.IS_ALERT_SUCCESS, false));
            }}
          />
          <br />
        </RBHBox>
      );
    } else if (isAlertFailure) {
      return (
        <RBHBox id={'alertFailure'} data-testid={'alertFailure'}>
          <RBHAlert
            type={'error'}
            text={'main.mart.product.delete.alert.failure'}
            autoCloseDuration={3000}
            afterClose={() => {
              dispatch(martProductCreators.setMartProductState(MART_PRODUCT_STATE_KEY.IS_ALERT_FAILURE, false));
            }}
          />
          <br />
        </RBHBox>
      );
    } else {
      return null;
    }
  };

  const BreadcrumbRender = () => {
    return (
      <Breadcrumb style={styleText.breadCrumb}>
        <Breadcrumb.Item>
          <a data-testid={'breadcrumbMartCategoryToHome'} id={'breadcrumbMartCategoryToHome'} style={styleText.breadCrumbItemLink}
            onClick={() => toPath('/main')}>
            <FormattedMessage id={'main.main'} />
          </a>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <span data-testid={'breadcrumbMartProduct'} id={'breadcrumbMartProduct'} style={styleText.breadCrumbItem}>
            <FormattedMessage id={'main.mart.product.landing.breadcrumb'} />
          </span>
        </Breadcrumb.Item>
      </Breadcrumb>
    );
  };

  const BreadcrumbEditRender = () => {
    return (
      <RBHBox>
        <Breadcrumb style={styleText.breadCrumb}>
          <Breadcrumb.Item>
            <a data-testid={'breadcrumbHomepageEdit'} id={'breadcrumbHomepageEdit'} style={styleText.breadCrumbItemLink} onClick={() =>
              dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true,
                onOk: () => toPath('/main'),
                type: MODAL_TYPE.CONFIRM_EDIT
              }))}>
              <FormattedMessage id={'main.main'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a data-testid={'breadcrumbProductListEdit'} id={'breadcrumbProductListEdit'} style={styleText.breadCrumbItemLink} onClick={() =>
              dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true, onOk: pushToMartProduct, type: MODAL_TYPE.CONFIRM_EDIT
              }))}>
              <FormattedMessage id={'main.mart.product.landing.breadcrumb'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span data-testid={'breadcrumbEditProduct'} id={'breadcrumbEditProduct'} style={styleText.breadCrumbItem}>
              <FormattedMessage id={'main.mart.product.edit.breadcrumb'} />
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </RBHBox>
    );
  };

  const TooltipBoxPromotionPeriodInfo = () => {
    return (
      <RBHBox style={styles.tooltipBoxPromotionPeriodInfo} id={'tooltipBoxPromotionPeriodInfo'}>
        <FormattedMessage id={'main.mart.product.landing.table.promotionPeriodInfo.tooltip.content1'} />
      </RBHBox>
    );
  };

  const columns = [
    {
      width: metrics.tableHeader.width365,
      title: <FormattedMessage id={'main.mart.product.landing.table.productName'} />,
      className: 'product-name-header',
      dataIndex: 'productName',
      key: 'productName',
      sortOrder: sortedInfo.columnKey === 'productName' && sortedInfo.order,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => {
        return (
          <RBHBox style={{ padding: '14px 10px' }}>
            <RBHTextInput
              placeholder={'main.mart.product.landing.table.name.search.placeholder'}
              data-testid={'searchProductInput'}
              id={'searchProductInput'}
              style={styleInput.inputTableSearch}
              value={selectedKeys[0]}
              onChange={(e: any) => {
                setSelectedKeys([e?.target?.value]);
              }}
              autoComplete={'off'}
              onPressEnter={confirm}
              onBlur={confirm}
              defaultValue={searchedProductName}
            />
          </RBHBox>
        );
      },
      filterIcon: () => (
        <SearchOutlined data-testid={'searchProductIcon'} id={'searchProductIcon'} translate={null}
          style={{ color: searchedProductName ? Colors.lightPurple : Colors.font.primary.gray }} />
      ),
      onFilterDropdownVisibleChange: (visible: boolean) => {
        if (visible) {
          setTimeout(() => {
            const inputEl = document.getElementById('searchProductInput');
            if (inputEl) {
              (inputEl as HTMLInputElement).focus();
            }
          }, 250);
        }
      },
      sorter: true,
      render: (value: string, all: any, index: number) => {
        const isDisplayPromotionPeriod = !!all.promoStartDateTime && !!all.promoEndDateTime;
        let startDateTime;
        let endDateTime;
        if (isDisplayPromotionPeriod) {
          startDateTime = UtilHelper.formatToBuddhistYear(moment(all.promoStartDateTime), UtilHelper.formatDateTime01);
          endDateTime = UtilHelper.formatToBuddhistYear(moment(all.promoEndDateTime), UtilHelper.formatDateTime01);
        }

        return (
          <RBHBox id={`productInfo-${index}`}>
            <RBHBox style={styles.imageBox}>
              <RBHImage id={`productImg-${index}`} data-testid={`productImg-${index}`} src={all.productPhoto || Images.productDefault}
                onError={(e: any) => e.target.src = Images.productDefault} style={styles.image} />
            </RBHBox>
            <RBHBox style={styles.menuNameBox}>
              <RBHBox style={styleText.textTableContentFakeBlack} id={`productNameTH-${index}`} data-testid={`productNameTH-${index}`}>
                {all.productNameTH}
              </RBHBox>
              <RBHBox style={styleText.textRegularGray} id={`productNameEN-${index}`} data-testid={`productNameEN-${index}`}>
                {all.productNameEN}
              </RBHBox>
              {(!!all?.productWeightProduct || !!all.productSizeProduct) &&
                <RBHBox style={styles.textLimitItem} id={`productLimit-${index}`} data-testid={`productLimit-${index}`}>
                  {all.productWeightProduct
                    ? all.productWeightProduct?.productWeightProductDisplayTh
                    : all.productSizeProduct?.productSizeProductDisplayTh
                  }
                </RBHBox>
              }
              {
                isDisplayPromotionPeriod && (
                  <RBHBox style={styles.promotionPeriodBox}>
                    <ClockCircleOutlined translate={null} style={styles.promotionPeriodIcon} />
                    <RBHText id={`promotionPeriod-${index}`} data-testid={`promotionPeriod-${index}`} style={styles.promotionPeriodText}>
                      <FormattedMessage id={'main.mart.product.landing.table.promotionPeriod'} values={{ startDateTime, endDateTime }} />
                    </RBHText>
                  </RBHBox>
                )
              }
            </RBHBox>
          </RBHBox>
        );
      }
    },
    {
      title: <FormattedMessage id={'main.mart.product.landing.table.originalProductPrice'} />,
      className: 'product-price-header',
      dataIndex: 'originalProductPrice',
      key: 'originalProductPrice',
      sortOrder: sortedInfo.columnKey === 'originalProductPrice' && sortedInfo.order,
      align: 'left',
      sorter: true,
      render: (value: any, all: any, index: number) => {
        return (
          <RBHBox id={`originalProductPrice-${index}`} data-testid={`originalProductPrice-${index}`}>
            {UtilHelper.currencyFormat(value, true)}
          </RBHBox>
        );
      }
    },
    {
      title: <FormattedMessage id={'main.mart.product.landing.table.productPrice'} />,
      className: 'product-price-header',
      dataIndex: 'productPrice',
      key: 'productPrice',
      sortOrder: sortedInfo.columnKey === 'productPrice' && sortedInfo.order,
      align: 'left',
      sorter: true,
      render: (value: any, all: any, index: number) => {
        let formattedPromotionPriceText = '-';
        if (
          !isNil(all.productPrice) && !!all.originalProductPrice &&
          all.productPrice < all.originalProductPrice &&
          !isNil(all.promoStatus)
        ) {
          formattedPromotionPriceText = UtilHelper.currencyFormat(value, true);
        }

        return (
          <RBHBox style={styles.promotionPriceBox}>
            <RBHText id={`productPrice-${index}`} data-testid={`productPrice-${index}`} style={styles.promotionPriceText}>
              {formattedPromotionPriceText}
            </RBHText>
            {
              all.promoStatus === PROMOTION_STATUS.PENDING && (
                <RBHBox id={`tooltipPromotionPriceBox-${index}`} style={styles.tooltipPromotionPriceBox}>
                  <Tooltip id={'ant-tooltip-product-price-inner'} title={TooltipBoxPromotionPeriodInfo} placement={'bottomRight'}>
                    <InfoCircleOutlined translate={null} style={styles.promotionPriceInfoIcon} />
                  </Tooltip>
                </RBHBox>
              )
            }
          </RBHBox>
        );
      }
    },
    {
      className: 'product-category-header',
      dataIndex: 'productCategory',
      key: 'productCategory',
      sortOrder: sortedInfo.columnKey === 'productCategory' && sortedInfo.order,
      title: <FormattedMessage id={'main.mart.product.landing.table.productCategory'} />,
      sorter: true,
      render: (value: any, all: any, index: number) => {
        return (
          <RBHBox id={`productCategory-${index}`} data-testid={`productCategory-${index}`}>
            {all.productCategory.productCategoryNameTH}
          </RBHBox>
        );
      }
    },
    {
      title: <FormattedMessage id={'main.mart.product.landing.table.productStatus'} />,
      dataIndex: 'productStatus',
      key: 'productStatus',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => {
        return (
          <Menu selectable={false}>
            {
              productStatusCode.map((value: string, index: number) => {
                return (
                  <Menu.Item
                    key={value}
                    id={value}
                    style={filteredProductStatus === value ? styles.selectedMenuItem : {}}
                    onClick={() => onFilterClick(setSelectedKeys, selectedKeys, confirm, clearFilters, value)} >
                    <RBHText id={`productStatusOption-${index}`} data-testid={`productStatusOption-${index}`}
                      style={styleText.textTableContentFakeBlack} text={`main.mart.product.landing.table.productStatus.${value.toLowerCase()}`} />
                  </Menu.Item>
                );
              })
            }
          </Menu>
        );
      },
      filterIcon: () => (
        <FilterFilled id={'martProductFilterIcon'} data-testid={'martProductFilterIcon'} translate={null}
          style={{ color: filteredProductStatus ? Colors.lightPurple : Colors.font.primary.gray }} />
      ),
      onFilter: (value: boolean, record: any) => {
        return record.productStatus === value;
      },
      render: (value: string, all: any, index: number) => {
        return (<RBHBox>
          <RBHBox id={`productStatus-${index}`} data-testid={`productStatus-${index}`}>
            <FormattedMessage id={`main.mart.product.landing.table.productStatus.${value.toLowerCase()}`} />
          </RBHBox>
          <RBHQCTag qcStatus={all?.productQCStatus} id={`productQcStatus-${index}`} marginTop={2} />
        </RBHBox>
        );
      }
    },
    {
      title: <FormattedMessage id={'main.mart.product.landing.table.productEdit'} />,
      align: 'center',
      render: (value: any, all: any, index: number) => {
        const productEdit = `productEdit-${index}`;
        const productEditIcon = `productEditIcon-${index}`;
        return (
          <RBHBox
            id={productEdit}
            data-testid={productEdit}
            onClick={() => {
              dispatch(httpCreators.request({
                id: MART_CATEGORY_REQUEST_ID_LIST.GET_MART_CATEGORY,
                sagaHandler: martCategorySagas.getMartCategoryThenTncHandler as any,
                callbackParams: {
                  onSuccessCallback: (tagMaster: Tags[]) => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    const tag = tagMaster.find(value => value.tagId === all.tagId)
                    if (tag?.isDeleted) {
                      setEditData(all);
                    } else {
                      setEditData({ ...all, tag });
                    }
                  },
                  onFailureCallback: () => {
                    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                      visible: true,
                      type: MODAL_TYPE.ERROR,
                      onOk: noop,
                    }));
                  },
                },
                service: MartCategoryService.getMartCategory,
              }));
            }}
          >
            <EditOutlined data-testid={productEditIcon} id={productEditIcon} translate={null} style={styleImage.iconTable} />
          </RBHBox>);
      },
    },
    {
      title: <FormattedMessage id={'main.mart.product.landing.table.productDelete'} />,
      align: 'center',
      dataIndex: 'productId',
      render: (value: any, all: any, index: number) => {
        const productDelete = `productDelete-${index}`;
        const productDeleteIcon = `productDeleteIcon-${index}`;
        return (
          <RBHBox id={productDelete}>
            <DeleteOutlined data-testid={productDeleteIcon} id={productDeleteIcon}
              onClick={() => dispatchModal(value)} translate={null} style={styleImage.iconTable} />
          </RBHBox>);
      },
    }
  ];

  const onShowSizeChange = (current: any, pageSize: number) => {
    dispatch(martProductCreators.callMartProductTnc({
      searchProductName: searchedProductName,
      productStatus: filteredProductStatus,
      productSort: productSorted,
      offset: 0,
      limit: pageSize
    }, false));
    setPageSizeItems(pageSize);
    setOffset(0);
    setLimit(pageSize);
    setCurrentPage(1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const onChangePage = (pageNumber: number) => {
    const offsetFormula = (pageNumber - 1) * pageSizeItems;
    dispatch(martProductCreators.callMartProductTnc({
      searchProductName: searchedProductName,
      productStatus: filteredProductStatus,
      productSort: productSorted,
      offset: offsetFormula,
      limit
    }, false));
    setCurrentPage(pageNumber);
    setOffset(offsetFormula);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const sortedField = (sorter: any) => {
    switch (sorter.field) {
      case 'productName': {
        return 'product.product_name_th';
      }
      case 'originalProductPrice': {
        return 'product.original_product_price';
      }
      case 'productPrice': {
        return 'product.product_price';
      }
      case 'productCategory': {
        return 'product_category.product_category_name_th';
      }
      default: {
        return null;
      }
    }
  };

  const checkFilterStatus = (filters: any) => {
    const filterProductStatus = filters?.productStatus?.toString();
    if (filterProductStatus === filteredProductStatus) {
      return null;
    } else if (filterProductStatus !== undefined) {
      return filterProductStatus;
    } else {
      return filteredProductStatus;
    }
  };

  const checkSearchProductName = (filters: any) => {
    const searchProductName = filters?.productName?.toString();
    if (searchProductName === searchedProductName || searchProductName === '') {
      return null;
    } else if (searchProductName !== undefined) {
      return searchProductName;
    } else {
      return searchedProductName;
    }
  };

  const onChange = (pagination: any, filters: any, sorter: any) => {
    // Given
    const searchProductName = filters?.productName?.toString();
    const filterProductStatus = filters?.productStatus?.toString();
    // check if any sort click?
    const productSort = sorter.order
      ? [{
        sortName: sortedField(sorter),
        sortOrder: sorter.order === 'ascend' ? 'asc' : 'desc'
      }]
      : null;
    console.log('sorter :>> ', sorter);
    console.log('productSort :>> ', productSort);
    // When call api send data
    dispatch(martProductCreators.callMartProductTnc({
      searchProductName: checkSearchProductName(filters),
      productStatus: checkFilterStatus(filters),
      productSort,
      offset: searchProductName || filterProductStatus ? 0 : offset,
      limit
    }, false));

    // Then set state
    setSortedInfo({
      order: sorter.order,
      columnKey: sorter.field,
    });
    setSearchedProductName(checkSearchProductName(filters));
    setFilteredProductStatus(checkFilterStatus(filters));
    setProductSorted(productSort);
  };

  const TableRender = () => {
    return (
      <RBHTable
        rowKey={(record: { productId: number; }) => record.productId}
        loading={loading}
        columns={columns}
        dataSource={data}
        rowClassName={(record: any) => (record.productStatus === MART_PRODUCT_STATUS.INACTIVE ? 'disabled' : '')}
        showSorterTooltip={false}
        locale={{
          emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={<span id={'dataNotFound'} data-testid={'dataNotFound'}>
              <FormattedMessage id={'main.table.notFound'} /> </span>} />
        }}
        onChange={onChange}
        pagination={{
          style: styleText.formText,
          locale: { items_per_page: '/ หน้า' },
          showSizeChanger: true,
          onShowSizeChange,
          onChange: onChangePage,
          current: currentPage,
          pageSizeOptions: MART_PRODUCT_LIST_PAGE_OPTION,
          pageSize: pageSizeItems,
          total: totalItems,
          position: ['bottomLeft'],
          responsive: true,
          showTotal: () => {
            return (
              <RBHText style={styleText.textPaginationShowTotal}>
                <FormattedMessage id={'main.showing'} />
                <span> {offset + 1}-{isLastPage ? totalItems : offset + limit} </span>
                <FormattedMessage id={'main.of'} />
                <span> {totalItems}</span>
              </RBHText>
            );
          }
        }}>
      </RBHTable>
    );
  };

  const AddProductButton = () => {
    return (
      <RBHButton
        id={'addProductButton'}
        data-testid={'addProductButton'}
        style={styleButton.buttonAdd}
        text={'main.mart.product.landing.btn.addProduct'}
        type={'primary'}
        onClick={() => toPath('/main/addmartproduct')}
      />
    );
  };

  const EmptyProduct = () => {
    return (
      <RBHBox style={styles.emptyWrapper}>
        <Row style={{ justifyContent: 'center' }}>
          <RBHImage style={{ ...styleImage.icon200 }} src={Images.emptyState}
            data-testid={'emptyProduct-img'} id={'emptyProduct-img'} />
        </Row>
        <RBHText style={styles.emptyProductHeader} text={'main.mart.product.landing.empty.header'}
          data-testid={'emptyProduct-header'} id={'emptyProduct-header'} />
        <RBHText style={styles.emptyProductDesc} text={'main.mart.product.landing.empty.desc'}
          data-testid={'emptyProduct-desc'} id={'emptyProduct-desc'} />
        <Row style={{ justifyContent: 'center' }}>
          <AddProductButton />
        </Row>
      </RBHBox>
    );
  };

  const TabRender = (props: any) => {
    return (
      <RBHBox style={styles.header}>
        {props.textHeader &&
          <RBHText style={styleText.headerText} text={props.textHeader}
            data-testid={'martProduct-header'} id={'martProduct-header'} />
        }
        {data === undefined || data.length === 0
          ? null
          : AddProductButton()
        }
      </RBHBox>
    );
  };

  const qcRejectReasons = () => {
    return editData?.productRejectReason?.map((reasons: string, index: number) => {
      return (
        <RBHText style={styles.qcRejectReasons} data-testid={`qcRejectReasons-${index}`}
          id={`qcRejectReasons-${index}`} key={index}>
          {' ' + '• ' + reasons}
        </RBHText>
      );
    });
  };

  const messageQc = () => {
    return (
      <RBHBox>
        <RBHText style={styles.messageQc} data-testid={'qcRejectReasonHeader'} id={'qcRejectReasonHeader'}
          text={editData?.productRejectReason?.length === 0
            ? 'main.mart.product.qc.reject.header1'
            : 'main.mart.product.qc.reject.reasons.header1'} />
        {
          editData?.productRejectReason?.length > 0 &&
          <RBHBox style={styles.qcRejectReasonsBox}>
            {qcRejectReasons()}
          </RBHBox>
        }
        <RBHText style={styles.messageQc} data-testid={'qcRejectReasonBottom'}
          id={'qcRejectReasonBottom'} text={'main.foodmenu.addEdit.qc.reject.header2'} />
      </RBHBox>
    );
  };

  return (
    <RBHBox>
      <AlertBar />
      {editData ? <BreadcrumbEditRender /> : <BreadcrumbRender />}
      {loading ? null :
        editData ?
          <RBHBox>
            <RBHBox style={styles.header}>
              <RBHText style={styleText.headerText} text={'main.mart.product.edit.header'}
                data-testid={'headerEditProduct'} id={'headerEditProduct'} />
            </RBHBox>
            <RBHText data-testid={'qcRemark'} id={'qcRemark'} style={styles.subTitleText} text={'main.mart.product.addEdit.qc.desc'} />
            {
              editData?.productQCStatus === PDQC_STATUS.PDQC_REJECT &&
              <RBHBox style={styles.bannerBox}>
                <RBHBanner className={'bannerPadding'} style={styles.banner} message={messageQc()} />
              </RBHBox>
            }
            <RBHBox style={commonStyle.formWrapper}>
              <FormAddEdit editData={editData} onSuccessCallback={pushToMartProduct} onCancel={() =>
                dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                  visible: true,
                  onOk: pushToMartProduct,
                  type: MODAL_TYPE.CONFIRM_EDIT
                }))
              } />
            </RBHBox>
          </RBHBox>
          :
          <RBHBox>
            <TabRender textHeader={'main.mart.product.landing.header'} />
            <RBHText data-testid={'martProduct-subtitle'} id={'martProduct-subtitle'} style={styles.subTitleText} text={'main.mart.product.landing.subtitle'} />
            <RBHBox>
              {data === undefined
                ? <RBHError onOk={() => resetReload()} />
                // check if product empty form no data
                : data.length === 0 && (!searchedProductName && !filteredProductStatus && !productSorted)
                  ? EmptyProduct()
                  : <RBHBox style={styles.defaultContent}>
                    <TableRender />
                  </RBHBox>
              }
            </RBHBox>
          </RBHBox>
      }
      <RBHBox style={{ marginTop: metrics.base }}>
        <BackTop visibilityHeight={metrics.base * 40} style={styles.BackTop}>
          <RBHButton
            id={'backToTopButton'}
            data-testid={'backToTopButton'}
            style={styles.circleBox}
            shape={'circle'}
            icon={<VerticalAlignTopOutlined data-testid={'backToTopIcon'} id={'backToTopIcon'} translate={null} style={styles.iconBackToTop} />}
          />
        </BackTop>
      </RBHBox>
    </RBHBox>
  );
};

type Props = {};
